class NullPersistenceService {
  setUpdateIsNeeded() {
    // Do nothing
  }

  clear() {
    // Do nothing
  }

  isUpdateNeeded() {
    return false;
  }
}

export default NullPersistenceService;
